import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { IMDSSessionProps, IMDSSessionRef } from "./session.types";
import { MDSSessionProvider } from "./session-context";
import { MDSSessionContent } from "@/mds/components/sessions/session-content/session-content";
import { MDSSessionContextValue, MDSSessionErrorKind } from "./session-context";

export const MDSSession = forwardRef<IMDSSessionRef, IMDSSessionProps>((props, ref) => {
  const contextRef = useRef<MDSSessionContextValue | null>(null);

  useImperativeHandle(ref, () => ({
    upsertEvents: sessionEvents => {
      contextRef.current?.upsertSessionEvents(sessionEvents);
    },
    updateStatus: sessionStatus => {
      contextRef.current?.updateSessionStatus(sessionStatus);
    },
    minimizeSession: () => {
      contextRef.current?.minimizeSession();
    },
    expandSession: () => {
      contextRef.current?.expandSession();
    },
    setPreviewMode: () => {
      contextRef.current?.setPreviewMode(true);
    },
    setStandardMode: () => {
      contextRef.current?.setPreviewMode(false);
    },
    startCountdown: durationMs => {
      contextRef.current?.startCountdown(durationMs);
    },
    setSessionError: error => {
      contextRef.current?.setSessionError({
        type: MDSSessionErrorKind.SessionEventError,
        message: error.message,
        canRetry: error.canRetry,
      });
    },
    clearSessionError: () => {
      contextRef.current?.clearSessionError();
    },
    publishNotification: ({ notificationInfo }) => {
      contextRef.current?.publishNotification({ notificationInfo });
    },
    focusComboboxInput: () => {
      contextRef.current?.focusComboboxInput();
    },
  }));

  return (
    <MDSSessionProvider
      ref={contextRef}
      initialSessionEvents={props.initialSessionEvents}
      initialSessionStatus={props.initialSessionStatus}
      config={props.config}
      handlers={props.handlers}
    >
      <MDSSessionContent {...props} />
    </MDSSessionProvider>
  );
});
